const acceptedTypes = new Set(["image/jpeg", "image/png", "image/webp", "application/pdf"]);
export function validateIdentityFile(file) {
  if (!file) throw new Error("Choose a document to upload.");
  if (!acceptedTypes.has(file.type)) throw new Error("Choose a JPEG, PNG, WebP or PDF document.");
  if (file.size <= 0 || file.size > 5 * 1024 * 1024) throw new Error("Documents must be between 1 byte and 5 MB.");
}
export function readDocument(file) {
  validateIdentityFile(file);
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve({ originalName: file.name, mimeType: file.type, contentBase64: String(reader.result).split(",")[1] });
    reader.onerror = () => reject(new Error("The document could not be read. Please select it again."));
    reader.onabort = () => reject(new Error("The document could not be read. Please select it again."));
    reader.readAsDataURL(file);
  });
}
export function documentBlob(document) {
  if (!acceptedTypes.has(document?.mimeType) || typeof document.contentBase64 !== "string") throw new Error("The document is unavailable.");
  const bytes = Uint8Array.from(atob(document.contentBase64), char => char.charCodeAt(0));
  return new Blob([bytes], { type: document.mimeType });
}
